export default __webpack_public_path__ + "static/bone-broth-135bd630452669e51cb955230c0dfc91.png";